import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { EmployeeBusinessesState, employeeBusinessesKey } from '../reducers/employee-businesses.reducer';
import * as employeeBusinessesState from '../reducers/employee-businesses.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, EmployeeBusinessesState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee GenerateOtp SUB STATE
export const getEmployeeBusinessesState = createSelector(getMainEmployeeState, state => state[employeeBusinessesKey]);
//#endregion

//#region Employee GenerateOtp SUB STATE
export const getEmployeeBusinessesRequest = createSelector(
  getEmployeeBusinessesState,
  employeeBusinessesState.getEmployeeBusinessesRequest
);
export const getEmployeeBusinessesSuccess = createSelector(
  getEmployeeBusinessesState,
  employeeBusinessesState.getEmployeeBusinessesResponse
);
export const getEmployeeBusinessesFailure = createSelector(
  getEmployeeBusinessesState,
  employeeBusinessesState.getEmployeeBusinessesFailure
);
//#endregion
